package team.platforma.multiplatform_material_extension.ui.core

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.text.input.TextFieldValue
import kotlinx.datetime.LocalDate
import team.platforma.multiplatform_material_extension.ui.drop_down.model.ListItem


@Composable
internal fun rememberInputFieldState(): InputFieldState {
    return remember { InputFieldStateImpl() }
}


internal interface InputFieldState {
    fun changeValue(string: String)
    fun changeValue(textFieldValue: TextFieldValue)
    fun changeLocalDate(localDate: LocalDate)
    fun endIconClick()
    fun setAutocompleteItem(item: ListItem)

    fun addListener(listener: InputFieldStateListener)
    fun removeListener(listener: InputFieldStateListener)

}

internal interface InputFieldStateListener {
    fun onValueChange(string: String) {}
    fun onValueChange(textFieldValue: TextFieldValue) {}
    fun onEndIconClick() {}
    fun onAutocompleteItemSet(item: ListItem) {}
    fun onLocalDateChange(localDate: LocalDate) {}

}

private class InputFieldStateImpl : InputFieldState {
    private val listeners = mutableListOf<InputFieldStateListener>()
    override fun changeValue(string: String) {
        listeners.forEach {
            it.onValueChange(string)
        }
    }

    override fun changeValue(textFieldValue: TextFieldValue) {
        listeners.forEach {
            it.onValueChange(textFieldValue)
        }
    }

    override fun changeLocalDate(localDate: LocalDate) {
        listeners.forEach {
            it.onLocalDateChange(localDate)
        }
    }

    override fun endIconClick() {
        listeners.forEach {
            it.onEndIconClick()
        }
    }

    override fun setAutocompleteItem(item: ListItem) {
        listeners.forEach {
            it.onAutocompleteItemSet(item)
        }
    }

    override fun addListener(listener: InputFieldStateListener) {
        listeners.add(listener)
    }

    override fun removeListener(listener: InputFieldStateListener) {
        listeners.remove(listener)
    }
}




